import React from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

type BrandLogoProps = {
  variant?: 'default' | 'onDark';
  className?: string;
  imgClassName?: string;
  to?: string | null;
};

export default function BrandLogo({
  variant = 'default',
  className,
  imgClassName,
  to = '/',
}: BrandLogoProps) {
  const src = variant === 'onDark' ? '/logo-on-dark.png' : '/logo.png';
  const img = (
    <img
      src={src}
      alt="Consular Capital"
      className={twMerge('h-8 w-auto md:h-9', imgClassName)}
      decoding="async"
    />
  );

  if (to === null) {
    return <div className={className}>{img}</div>;
  }

  return (
    <Link to={to} className={twMerge('inline-flex items-center', className)}>
      {img}
    </Link>
  );
}
